import { ChangeDetectorRef, Component, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { FiltersM, typesApex } from '../../../components/models';
import { DataService } from '../../../services/data/data.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { SegPresupuestalService } from '../../../services/segimiento-presupuestal/seg-presupuestal.service';
import { first, firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { companiesSegPresupuestal } from '../../../shared/catalogos';
import { cuentaEntity, detalleCuentaEntity, detalleIndicadorEntity, evaluacionesAllEntity, evaluacionesEntity, gruposIndEntity, indicadorEntity, sucursalesEntity} from '../../../services/segimiento-presupuestal/Manual/entities';
import { periodos } from '../../funciones/funcionesGenerales';
import { Periodos } from '../funcionesFormuladorSeguimiento';

@Component({
  selector: 'app-analisis-sucursales',
  templateUrl: './analisis-sucursales.component.html',
  styleUrl: './analisis-sucursales.component.css'
})
export class AnalisisSucursalesComponent {
  @ViewChildren(GraficadorComponent) grafCmp!: QueryList<GraficadorComponent>;
  public tagInstitucion: number;
  public Filters = FiltersM;
  public Periodos: any[] = [];
  public periodoSeleccionado: any = null;
  public escenarios: any[] = [];
  public escenarioSeleccionado;
  public sucursales: any[] = [];
  private institucionId = undefined;
  private idBase: any;
  private templateId = undefined;
  public typeGrap = typesApex;
  public cuentaSelect = {name: '', id: undefined};
  public dataCuentas = [];
  public grafCuenta = {titulo: '', filtroActivado: false, showLabels: false, tipo: this.typeGrap.COMBO, data: [], etiquetas:[]};
  public indSelect = {name: '', id: undefined};
  public dataIndicadores = [];
  private indicadores = [];
  public grafIndicador = {titulo: '', filtroActivado: false, showLabels: false, tipo: this.typeGrap.COMBO, data: [], etiquetas:[]};
  public coloresGraf2 = ['#FFCB03', '#68B4D6', '#82CC60'];
  public modalOpen: boolean = false;
  public tituloModal: string = ''
  public graficaAmp: number;
  public grafTab1 = true; // true->grafica, false->tabla
  public grafTab2 = true; // true->grafica, false->tabla
  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    public cookies: CookieService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService,
    private segPresupuestalService: SegPresupuestalService,
  ) {
    this.institucionId = this.cookies.get('idInstitucion');
    this.idBase = companiesSegPresupuestal.find(i => i.id === this.institucionId).idBack;
    this.personalizacion();
    this.initSucursales();
    this.initEscenarios();
  }
  private personalizacion(){
    this.tagInstitucion = companiesSegPresupuestal.find( i => i.id == this.institucionId).etiquetas;
  }
  private async initEscenarios() {
    try{
      let sucursalEntity: sucursalesEntity = {agrupadorId: this.idBase, tipoInstitucionId: 3};
      let res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.escenarios = res.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        check: false,
        ...rest
      }))
      this.escenarios[0].check = true;
      this.escenarioSeleccionado = this.escenarios[0];
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }   
  }
  private async initSucursales() {
    try{
      let res = [];
      let sucursalEntity: sucursalesEntity =  {id: this.idBase};
      const matriz = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.templateId = matriz[0].plantillaId;
      let consolidado = {name: 'Consolidado', consolidado: true, check: true, id: this.idBase};
      this.sucursales.push(consolidado)
      sucursalEntity = {agrupadorId: this.idBase, tipoInstitucionId: 5};
      res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      const resFiltro = res.filter(i => ((i.acronimo).toLowerCase()).includes('real'));
      const resEsce = res.filter(i => ((i.acronimo).toLowerCase()).includes('presupuesto'));
      const s = new Set();
      const sucur = resFiltro.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        consolidado: false,
        check: true,
        ...rest,
      })).filter( i => {
        if(s.has(i.name))
          return false;
        s.add(i.name);
        return true;
      });
      this.sucursales.push(... sucur);
      for(const suc of this.sucursales){
        if(suc.consolidado){
          suc['instEsce'] = this.escenarios;
        }else{
          const nombreSucursal = suc.name.trim().toLowerCase();

          suc.instEsce = resEsce.filter(item =>
            item.institucion.toLowerCase().includes(nombreSucursal)
          );
        }        
      }
      this.initPeriodos();
    }catch(e){
      console.warn(e)
      messages.errorMessageGraph(e.error);
    }
  }
  private async initPeriodos() {
    try{
      let evaluaciones: evaluacionesAllEntity;
      let evaEsce = [], esceSuc = {}, realSuc = {};
      //buscamos cada escenario(institucion) para cada sucursal
      for(const suc of this.sucursales){
        evaEsce = [];
        evaluaciones = {plantillaId: this.templateId, institucionId: suc.id};
        const evaReal = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
        //Buscamos las evaluaciones para cada escenario 
        for(const esce of suc.instEsce){
          
          evaluaciones = {plantillaId: this.templateId, institucionId: esce.id};
          const data = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones))
          evaEsce.push(data)
        }
        realSuc[suc.id] = {evaEsce: evaReal}
        esceSuc[suc.id] = {evaEsce: evaEsce};
      }
      const info = Periodos.evaluacionesSursales(realSuc, esceSuc);
      this.Periodos = info.periodos;
      this.periodoSeleccionado = info.perSeleccionado;
      this.initCuentas();
      this.initIndicadores();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }
  private async initCuentas(){
    if (!this.templateId) {
      this.dataCuentas = [];
      return;
    }

    try {
      let cuentaDesc: cuentaEntity = {plantillaId: this.templateId}
      let cuentaValor: detalleCuentaEntity;
      const res: any = await firstValueFrom(this.segPresupuestalService.getCuentasDescripcion(cuentaDesc));
      let dataPresupuestos = {}, dataReales = {};
      const idEvaEsce = this.escenarios.findIndex(e => e.check);
      for(const suc of this.sucursales){
        cuentaValor = {idEvaluacion: this.periodoSeleccionado.idReal[suc.id].id};
        const dataReal = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
        dataReales[suc.id] = dataReal.data.detalleEvaluacionCuentas;
        cuentaValor = {idEvaluacion: this.periodoSeleccionado.idPresupuesto[suc.id][idEvaEsce].id};
        const dataPresupuesto = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
        dataPresupuestos[suc.id] = dataPresupuesto.data.detalleEvaluacionCuentas;
      }
      
      if (!res || res.length === 0) {
        this.dataCuentas = [];
        return;
      }

      this.dataCuentas = res.map((r: any) => {
        const presupuestos = {}, reales = {}, cumplimientos = {}
        for(const suc of this.sucursales){
          const presupuesto = dataPresupuestos[suc.id].find(i => i.idCuenta === r.id).valor;
          const real = dataReales[suc.id].find(i => i.idCuenta === r.id).valor;
          const cumplimiento = !isNaN((100 * presupuesto) / real) ? Number(((100 * presupuesto) / real).toFixed(2)) : 0; 
          presupuestos[suc.id] = presupuesto;
          reales[suc.id] = real;
          cumplimientos[suc.id] = cumplimiento;
        }        
        
        return {
          id: r.id,
          codigo: r.code,
          name: r.cuenta,
          padre: r.cuentaPadreId,
          check: false,
          presupuesto: presupuestos,
          real: reales,
          cumplimiento: cumplimientos,
        };
      });
      this.dataCuentas[1].check = true;
      this.cuentaSelect = this.dataCuentas[1];
      this.generarGrafCuenta();
    } catch (e) {
      console.warn(e)
      messages.errorMessageGraph(e);
    }
  }
  private async initIndicadores(){
    try{
      this.dataIndicadores = [];
      if(!this.templateId){this.dataIndicadores = []; return;}
      let idModulo = 1;
      let grupoEntity: gruposIndEntity = {plantillaId: this.templateId, moduloId: idModulo};
      const grupos = await firstValueFrom(this.segPresupuestalService.getgrupoInd(grupoEntity));
      let indiEntity: indicadorEntity = {plantillaId: this.templateId};
      const indi = await firstValueFrom(this.segPresupuestalService.getIndicadoresPropiedades(indiEntity))
      let dataPresupuestos = {}, dataReales = {};
      let indiValor: detalleIndicadorEntity;
      const idEvaEsce = this.escenarios.findIndex(e => e.check);
      for(const suc of this.sucursales){
        indiValor = {idEvaluacion: this.periodoSeleccionado.idReal[suc.id].id};
        const dataReal = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
        dataReales[suc.id] = dataReal.data.detalleEvaluacionIndicadors;
        indiValor = {idEvaluacion: this.periodoSeleccionado.idPresupuesto[suc.id][idEvaEsce].id};
        const dataPresupuesto = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
        dataPresupuestos[suc.id] = dataPresupuesto.data.detalleEvaluacionIndicadors;
      }

      this.indicadores = grupos.map(({grupoIndicador, ...rest})=>({
        name: grupoIndicador,
        // check: true,
        ...rest
      }))
            
      for(const ind of this.indicadores){
        const indgrupo = await firstValueFrom(this.segPresupuestalService.getindicadorGrupo(ind.id));
        // this.dataIndicadores.push({grupoid: ind.id,nombre: ind.name, presupuesto: 0, real: 0, variacion: 0, paramMeta: 0, formula: '', semaforo: '', nivel: 1, check:ind.check, expandido: true});
        for(const g of indgrupo){
          const indicador = indi.find(d => d.id === g.indicadorId);
          const presupuestos = {}, reales = {}, variaciones = {}
          for(const suc of this.sucursales){
            const presupuesto = dataPresupuestos[suc.id].find(v => v.idIndicador === indicador.id).valor;
            const real = dataReales[suc.id].find(v => v.idIndicador === indicador.id).valor;
            const variacion = !isNaN( presupuesto - real) ? Number(( presupuesto - real).toFixed(2)) : 0; 
            presupuestos[suc.id] = presupuesto;
            reales[suc.id] = real;
            variaciones[suc.id] = variacion;
          }    
          this.dataIndicadores.push({
            grupoid: ind.id,
            id: indicador.id,
            code: indicador.code,
            name: indicador.indicador, 
            presupuesto: presupuestos, 
            real: reales, 
            variacion: variaciones, 
            paramMeta: 0, 
            formula: indicador.comentario,
            check: false,
          });
        }
      }
      this.dataIndicadores[0].check = true;
      this.indSelect = this.dataIndicadores[0];
      this.generarGrafIndicador();
    }catch(e){
      messages.errorMessageGraph(e.error);
    }    
  }
  public cambioPeriodo(per: any) {
    if (!per) return;
    
    // Si el objeto tiene propiedades 'mes' y 'anio', es un mes
    if (per.mes && per.anio) {
      // Actualizar solo el mes seleccionado
      this.Periodos.forEach(p => {
        if (p.series) {
          p.series.forEach(mes => {
            mes.check = (mes.mes === per.mes && mes.anio === per.anio);
          });
        }
      });
      this.periodoSeleccionado = per;
      this.initCuentas();
      this.initIndicadores();
    }
  }
  public async sucursalChange(sucClick: any) {
    for (const suc of this.sucursales) {
      if (suc.name === sucClick.name) {
        suc.check = !suc.check;
      }
    }
    this.generarGrafCuenta();
    this.generarGrafIndicador();
  }
  public numPerSelect(){
    var selecc = 0;
    for(const suc of this.sucursales){
      if(suc.check){
        selecc++;
      }
    }
    if(selecc > 1)
      return true;
    return false;
  }
  public escenarioChange(escClick: any) {
    if (!escClick || !escClick.name) return;

    this.escenarios.forEach(e => e.check = (e.name === escClick.name));
    const seleccionado = this.escenarios.find(e => e.check);
    this.escenarioSeleccionado = seleccionado;
    this.initCuentas();
    this.initIndicadores();
  }
  public resetFilters(){
    const ultimoAnio = this.Periodos[this.Periodos.length - 1];

    if (ultimoAnio) {
      this.periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      this.periodoSeleccionado.check = true;
    }

    for (const esc of this.escenarios) {
      esc.check = false;
    }
    this.escenarios[0].check = true;
    this.escenarioSeleccionado = this.escenarios[0];

    for (const suc of this.sucursales) {
      suc.check = true;
    }
    this.initCuentas();
    this.initEscenarios();
  }  
  public cambiarCuenta(cuenta){
    if(!cuenta || !cuenta.name) return;
    this.dataCuentas.forEach(e => e.check = (e.name === cuenta.name));
    const seleccionado = this.dataCuentas.find(e => e.check);
    this.cuentaSelect = seleccionado;
    this.generarGrafCuenta();
  }
  public cambiarIndicador(ind){
    if(!ind || !ind.name) return;
    this.dataIndicadores.forEach(e => e.check = (e.name === ind.name));
    const selec = this.dataIndicadores.find(e => e.check);
    this.indSelect = selec;
    this.generarGrafIndicador();
  }
  private generarGrafCuenta(){
    var etiquetas = [], cumplimiento = [], presupuesto = [], real = [];
    for(const s of this.sucursales){
      if(s.check){
        etiquetas.push(s.name);
        presupuesto.push(this.cuentaSelect['presupuesto'][s.id]);
        real.push(this.cuentaSelect['real'][s.id]);
        cumplimiento.push(this.cuentaSelect['cumplimiento'][s.id]);
      }
    }
    
    this.grafCuenta.titulo = this.cuentaSelect.name;
    this.grafCuenta.etiquetas = etiquetas;
    this.grafCuenta.data = [
      {name: 'Cumplimiento (%)', data: cumplimiento},
      {name: 'Presupuesto', data: presupuesto},
      {name: 'Ejecutado real', data: real},
    ];
  }
  private generarGrafIndicador(){
    var etiquetas = [], cumplimiento = [], presupuesto = [], real = [];
    for(const s of this.sucursales){
      if(s.check){
        etiquetas.push(s.name);
        presupuesto.push(this.indSelect['presupuesto'][s.id]);
        real.push(this.indSelect['real'][s.id]);
        cumplimiento.push(this.indSelect['variacion'][s.id]);
      }
    }
    
    this.grafIndicador.titulo = this.indSelect.name;
    this.grafIndicador.etiquetas = etiquetas;
    this.grafIndicador.data = [
      {name: 'Variacion', data: cumplimiento},
      {name: 'Presupuesto', data: presupuesto},
      {name: 'Ejecutado real', data: real},
    ];
  }
  public cambiarTipoGrafica(tipo: string, zona: number) {
    if(zona == 1){
      this.grafTab1 = true;
      this.grafCuenta.tipo = this.typeGrap[tipo];
    }else{
      this.grafTab2 = true;
      this.grafIndicador.tipo = this.typeGrap[tipo];
    }    
    this.cdr.detectChanges();
  }
  public ampliarGraf(zona: number){
    this.graficaAmp = zona;
    this.tituloModal = zona === 1 ? this.cuentaSelect.name : this.indSelect.name;
    this.modalOpen = true;
  }
  public exportarGrafica(zona: number){
    var titulos;
    if(zona === 1){
      titulos = {
        titulo: this.grafCuenta.titulo,
        subtitulo: this.periodoSeleccionado.nombre,
        nombreArch: `${this.grafCuenta.titulo}`
      }
    }
    if(zona === 2){
      titulos = {
        titulo: this.grafIndicador.titulo,
        subtitulo: '',
        nombreArch: `${this.grafIndicador.titulo}`
      }
    }
    const comp = this.grafCmp.find(g => g.zona === zona)
    comp.exportImg(zona, titulos);
  }
  public exportarTabla(zona: number){
    var aux = [];
    var data_excel = [];
    var encabezado_excel = [
      this.translate.instant('segPresupuestal.analisisSucursales.titTab1'),
      this.translate.instant('segPresupuestal.analisisSucursales.titTab2'),
      this.translate.instant('segPresupuestal.analisisSucursales.titTab3'),      
    ];
    var alineacion = [Aligment.LEFT,Aligment.RIGHT,Aligment.RIGHT,Aligment.CENTER];
    var formato = [FormatText.TEXT,FormatText.NUMBER,FormatText.NUMBER,FormatText.PORCENTAJE]
    var tit = '';
    var nombreArch = '';
    if(zona == 0){
      encabezado_excel.push(this.translate.instant('segPresupuestal.analisisSucursales.titTab4'));
      let i = 0;
      for( const suc of this.grafCuenta.etiquetas){
        aux.push(suc);
        aux.push(this.grafCuenta.data[1].data[i])
        aux.push(this.grafCuenta.data[2].data[i])
        aux.push(this.grafCuenta.data[0].data[i]/100)
        data_excel.push(aux);
        aux = [];
        i++;
      }
      tit = `${this.cuentaSelect.name} | ${this.periodoSeleccionado.name} | ${this.escenarioSeleccionado.name}`;
      nombreArch = `${this.cuentaSelect.name} | ${this.periodoSeleccionado.name}`;
    }
    if(zona == 1){
      encabezado_excel.push(this.translate.instant('segPresupuestal.analisisSucursales.titTab5'));
      let i = 0;
      for( const suc of this.grafCuenta.etiquetas){
        aux.push(suc);
        aux.push(this.grafCuenta.data[1].data[i])
        aux.push(this.grafCuenta.data[2].data[i])
        aux.push(this.grafCuenta.data[0].data[i]/100)
        data_excel.push(aux);
        aux = [];
        i++;
      }
      tit = `${this.indSelect.name} | ${this.periodoSeleccionado.name} | ${this.escenarioSeleccionado.name}`;
      nombreArch = `${this.indSelect.name} | ${this.periodoSeleccionado.name}`;
    }
    this.excelService.generateExcel(tit,encabezado_excel,data_excel,nombreArch,alineacion,formato);
  }
  public formatoMoneda(valor: number | string): string {
    // Si es guion, devolverlo tal cual
    if (valor === '-') return '-';
    // Formatea el número con separadores de miles (comas)
    return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  public formatoPorcentaje(valor: number): string {
    // Formatea el porcentaje con símbolo %
    return Number(valor.toFixed(2)) + '%';
  }
  
}
